<template>
  <div id="electric">
    <div class="topPart">
      <div class="titlePart">
        <h2 class="title">智慧用电</h2>
        <div class="intro">
         根据对火灾原因的分析统计，电气类因素占比超过50%，高于其他隐患因素总和。在各类建筑之中，用电必不可少
        </div>
      </div>
      <el-row :gutter="30">
        <el-col
          :xs="24"
          :sm="12"
          :md="12"
          :lg="6"
          :xl="6"
          align="center"
          v-for="(item, index) in elePanelInfo"
          :key="index"
        >
          <div class="eleItem wow animate__zoomIn">
            <img :src="item.src" alt="" />
            <div class="eleTitle">{{ item.name }}</div>
            <div class="eleItemInfo">{{ item.desc }}</div>
          </div>
        </el-col>
      </el-row>
    </div>
    <div class="middlePart">
      <el-row class="middleRow">
        <el-col :xs="24" class="hidden-sm-and-up" align="center">
          <img
            src="../../../assets/img/product/zhyd.png"
            alt=""
            class="phoneShow"
          />
        </el-col>
        <el-col :xs="24" :sm="14" :md="14" :lg="14" :xl="14" align="center">
          <div class="itemTech wow fadeInUp">
            <div class="collapsePanel">
              <el-collapse accordion v-model="activeName">
                <el-collapse-item name="1">
                  <template slot="title">
                    <img
                      src="../../../assets/img/product/sxdl2.svg"
                      alt=""
                      v-if="activeName == 1"
                    />
                    <img
                      src="../../../assets/img/product/sxdl.svg"
                      alt=""
                      :style="{ display: activeName == 1 ? 'none' : '' }"
                    />
                    三相电流
                  </template>
                  <div class="contentTxt">
                    电气线路的设计都有一定的电流范围，当线路中出现大功率设备时，会导致电流超过额定上限，继而引起过负荷火灾。通过对三相电流分别监控，可以实时掌握电流大小，杜绝过负荷情况发生。
                  </div>
                </el-collapse-item>
                <el-collapse-item title="" name="2">
                  <template slot="title">
                    <img
                      src="../../../assets/img/product/sydl2.svg"
                      alt=""
                      v-if="activeName == 2"
                    />
                    <img
                      src="../../../assets/img/product/sydl.svg"
                      alt=""
                      :style="{ display: activeName == 2 ? 'none' : '' }"
                    />
                    剩余电流
                  </template>
                  <div class="contentTxt">
                    剩余电流也称为漏电流，当电气线路中不存在漏电时，剩余电流为0，通过监测剩余电流值可以实时了解线路漏电情况。
                  </div>
                </el-collapse-item>
                <el-collapse-item title="" name="3">
                  <template slot="title">
                    <img
                      src="../../../assets/img/product/sxwd2.svg"
                      alt=""
                      v-if="activeName == 3"
                    />
                    <img
                      src="../../../assets/img/product/sxwd.svg"
                      alt=""
                      :style="{ display: activeName == 3 ? 'none' : '' }"
                    />
                    四线温度
                  </template>
                  <div class="contentTxt">
                   电气线路温度是最直观反映火灾隐患的数据,通过温度传感器监测三线与零线温度，当发现温度过高或快速增加时，及时提醒用户，防患于未然。
                  </div>
                </el-collapse-item>
                <el-collapse-item title="" name="4">
                  <template slot="title">
                    <img
                      src="../../../assets/img/product/ydsj2.svg"
                      alt=""
                      v-if="activeName == 4"
                    />
                    <img
                      src="../../../assets/img/product/ydsj.svg"
                      alt=""
                      :style="{ display: activeName == 4 ? 'none' : '' }"
                    />
                    用电数据
                  </template>
                  <div class="contentTxt">
                    除了电气火灾监测功能之外，智慧用电系统还可以监测用户三相电有功、无功、功率、使用电能等数据，帮助分析用电习惯，数据化展示用电情况。
                  </div>
                </el-collapse-item>
              </el-collapse>
            </div>
          </div>
        </el-col>
        <el-col
          :xs="24"
          :sm="10"
          :md="10"
          :lg="10"
          :xl="10"
          align="center"
          class="hidden-xs-only pcShow"
        >
          <img
            src="../../../assets/img/product/zhyd.png"
            alt=""
            class="rightImg"
          />
        </el-col>
      </el-row>
    </div>
    <div class="lastPart">
      <h2 class="title2">智慧用电平台</h2>
      <div class="content">
        通过加装智能电表，实时监测配电柜数据，并通过分析运算，及时发现隐患、生成隐患信息，第一时间推送给相关人员，保障用电安全。
      </div>
      <div class="imgBox">
        <Viewer :srcArr="srcListArr" />
      </div>
    </div>
  </div>
</template>

<script>
import { WOW } from "wowjs";
import Viewer from "../../../components/viewer/viewer.vue";
export default {
  props: {},
  data() {
    return {
      elePanelInfo: [
        {
          name: "漏电火灾",
          desc:
            "线路某部位与电线或大地之间，有电流通过，产生漏电现象。泄漏的电流如遇电阻较大的部位时，会产生局部高温或漏电火花，并引燃附近的可燃物，从而造成火灾。",
          src: require("../../../assets/img/product/loudian2.svg"),
        },
        {
          name: "过负荷火灾",
        desc: "当导线中通过电流量超过了安全载流量时，导线绝缘层将会快速老化变质。当严重过负荷时，导线的温度也会不断升高，甚至会引起导线的绝缘层发生燃烧，并引燃附近的可燃物，从而造成火灾。",
          src: require("../../../assets/img/product/fuhe2.svg"),
        },
        {
          name: "短路火灾",
          desc: "线路绝缘受损后，火线与零线或地线产生接触，导致电流陡增，发生短路。短路瞬间的发热量极大，远超线路正常工作时的发热量，并在短路点易产生强烈的火花和电弧，能使绝缘层迅速燃烧，甚至金属熔化，并引燃附近的可燃物，从而造成火灾。",
          src: require("../../../assets/img/product/duanlu2.svg"),
        },
        {
          name: "接触电阻过大火灾",
          desc:
            "导线与导线、开关、电气设备等连接接头的接触面上形成的电阻称为接触电阻。在有大电流通过的电气线路上，如果出现接触电阻过大，就会在局部范围内产生极大的热量，使金属变色甚至熔化，并引燃附近的可燃物，从而造成火灾。",
          src: require("../../../assets/img/product/dianzu2.svg"),
        },
      ],
      active: 0,
      activeName: "1",
      srcListArr: [
        {
          src: require("../../../assets/img/product/e1.png"),
          name: "历史数据",
        },
        {
          src: require("../../../assets/img/product/e2.png"),
          name: "阈值报警",
        },
        { src: require("../../../assets/img/product/e3.png"), name: "数据统计" },
        {
          src: require("../../../assets/img/product/e4.png"),
          name: "用电分析",
        },
      ],
    };
  },
  computed: {},
  created() {},
  mounted() {
    new WOW({ live: false }).init();
  },
  watch: {},
  methods: {
    showModel() {
      this.dialogVisible = true;
    },
  },
  components: {
    Viewer,
  },
};
</script>

<style scoped lang="scss">
#electric {
  .topPart {
    padding: 5% 14%;
    .titlePart {
      text-align: center;
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      margin-bottom: 3rem;
      .title {
        font-size: 2.6rem;
        margin-bottom: 1rem;
      }
      .intro {
        width: 70%;
        color: #999999;
        font-size: 1.4rem;
        line-height: 2.2rem;
        text-align: center;
      }
    }
    .eleItem {
      cursor: pointer;
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      height: 36rem;
      width: 24rem;
      padding: 2rem;
      text-align: left;
      &:hover {
        box-shadow: 0px 1rem 2rem 0px rgba(48, 55, 66, 0.15);
        transform: translate(0, -5px);
        transition: all 0.3s;
      }
      img {
        width: 6.4rem;
        height: 6.4rem;
        border-radius: 50%;
      }
      .eleTitle {
        font-size: 1.6rem;
        margin: 3rem 0 1.5rem;
      }
      .eleItemInfo {
        height: 40%;
        font-size: 1.4rem;
        line-height: 2rem;
        color: #777777;
        text-align: justify;
        text-justify: inter-ideograph; /*IE*/
      }
    }
  }
  .middlePart {
    padding: 5% 14% 0;
    min-height: 55rem;
    .phoneShow {
      width: 100%;
    }
    .middleRow {
      .pcShow {
        .rightImg {
          width: 100%;
          height: 80%;
        }
      }
    }
    .itemTech {
      padding: 1rem;
      .title1 {
        font-size: 1.4rem;
        font-weight: 500;
        color: #666666;
        line-height: 4rem;
      }
      .title2 {
        color: #333333;
        line-height: 5rem;
        font-size: 2.6rem;
      }
      .line {
        font-weight: bold;
        border-bottom: 2px solid #535353;
        width: 16rem;
        margin: 2rem 0 1.4rem;
      }
      .content {
        font-size: 1.4rem;
        color: #777777;
        line-height: 2.2rem;
        width: 90%;
        text-align: justify;
        text-justify: inter-ideograph; /*IE*/
      }
      .collapsePanel {
        width: 60%;
        margin-top: 4rem;
        img {
          width: 2rem;
          height: 2rem;
          margin-right: 1rem;
        }
        /deep/.el-collapse {
          border: none;
        }
        /deep/.el-collapse-item__header.is-active {
          border-bottom-color: transparent;
          background: #18b09b;
          color: #fff;
          border-radius: 4px 4px 0 0;
        }
        /deep/.el-collapse-item__header {
          box-shadow: 0px 3px 60px 0px rgba(186, 186, 186, 0.19);
          margin-top: 1rem;
          border: none;
          padding: 0 1rem;
          border-radius: 4px;
        }
        /deep/ .el-collapse-item__wrap {
          box-shadow: 0px 3px 60px 0px rgba(186, 186, 186, 0.19);
          border: none;
          padding: 1rem;
          border-radius: 4px 4px 0 0;
        }
        /deep/ .el-collapse-item__arrow {
          color: #18b09b;
        }
        /deep/ .el-collapse-item__arrow.is-active {
          color: #ffffff;
        }
        .contentTxt {
          text-align: justify;
          text-justify: inter-ideograph;
          line-height: 2.2rem;
        }
      }
    }
  }
  .lastPart {
    padding: 5% 14%;
    .title2 {
      color: #333333;
      line-height: 5rem;
      font-size: 2.6rem;
      text-align: center;
      margin-bottom: 1rem;
    }
    .content {
      font-size: 1.4rem;
      color: #777777;
      line-height: 2.2rem;
      width: 100%;
      text-align: center;
      margin-bottom: 3rem;
    }
    .imgBox {
      .innerBox {
        position: relative;
        margin-top: 3rem;
        width: 100%;
        height: 33rem;
        .el-image {
          width: 100%;
          height: 100%;
          border-radius: 4px;
        }
        .tagName {
          position: absolute;
          top: 3rem;
          left: 3rem;
          background: rgba(0, 0, 0, 0.8);
          color: #ffffff;
          border-radius: 2rem;
          padding: 1rem 2rem;
        }
        .bigEye {
          position: absolute;
          bottom: 0rem;
          right: 0rem;
          cursor: pointer;
          background: #18b09b;
          width: 3rem;
          height: 3rem;
          border-radius: 0 0 4px 0;
        }
      }
    }
  }
  /deep/.el-dialog {
    background: none;
    box-shadow: none;
  }
  /deep/.el-dialog__body {
    height: 70vh;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  /deep/ .el-dialog__title {
    display: none;
  }
}
@import "../../../assets/responsive/electric.scss";
</style>
